import resourceId from '~/misc/resourceId';

const getTopQuery = (identity) => {
  // we want to get query which was filled by user
  if (identity.name === 'similarLoads') {
    return identity.parentIdentity.props.query;
  }
  return identity.props.query;
};

const backhaulIdentity = (loadIdentity) => {
  const originanFormQuery = loadIdentity.parentIdentity && getTopQuery(loadIdentity.parentIdentity);

  return resourceId('backhaul', {
    loadId: loadIdentity.props.id,
    loadIdentity,
    originanFormQuery,
  });
};

export default backhaulIdentity;



// WEBPACK FOOTER //
// ./src/modules/backhaul/backhaulIdentity.js